module.exports = __webpack_public_path__ + "static/img/D02-萧山区江南初级中学.ce8a202.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/D02-萧山区江南初级中学.png
// module id = mTaH
// module chunks = 0